import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import styled, { keyframes, css } from 'styled-components';
import { Box, Container, CardContent } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import Arrow_img from "../../../../public/Index_Page/icons/arrow.svg";
import { HeadingText, ParagraphText } from '../../../ui/TextFonts';
import cards from "../../../static-data/know-more.json";
import { variables } from '../../../styles/variables';

const Franchise_img = <svg width="88" height="89" viewBox="0 0 88 89" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect y="0.290039" width="88" height="88" rx="44" fill="#202020" />
  <path d="M42.3588 34.4223L37.4932 29.474C37.0243 29.0028 36.7898 28.453 36.7898 27.8246C36.7898 27.1963 37.0243 26.6465 37.4932 26.1752L42.3658 21.2269C42.8301 20.7557 43.3819 20.52 44.0212 20.52C44.6622 20.52 45.2218 20.7557 45.7001 21.2269L50.5657 26.1752C51.0346 26.6465 51.2691 27.1963 51.2691 27.8246C51.2691 28.453 51.0346 29.0028 50.5657 29.474L45.6931 34.4223C45.2288 34.8936 44.677 35.1292 44.0376 35.1292C43.3967 35.1292 42.8371 34.8936 42.3588 34.4223ZM20.5519 61.9913C19.8875 61.9913 19.331 61.7651 18.8823 61.3127C18.4337 60.8602 18.2086 60.301 18.207 59.635V52.566C18.207 51.2307 18.6666 50.1115 19.5858 49.2082C20.505 48.305 21.6086 47.8533 22.8967 47.8533H30.576C31.3576 47.8533 32.1001 48.0497 32.8036 48.4424C33.507 48.8351 34.0737 49.3653 34.5036 50.0329C35.6369 51.5646 37.0344 52.7624 38.6961 53.6263C40.3578 54.4903 42.1258 54.9223 44.0001 54.9223C45.9151 54.9223 47.7034 54.4903 49.3651 53.6263C51.0268 52.7624 52.404 51.5646 53.4967 50.0329C54.0047 49.3653 54.6011 48.8351 55.2858 48.4424C55.9705 48.0497 56.6833 47.8533 57.4243 47.8533H65.1036C66.4323 47.8533 67.5461 48.305 68.445 49.2082C69.3438 50.1115 69.7932 51.2307 69.7932 52.566V59.635C69.7932 60.3026 69.5681 60.8626 69.1179 61.315C68.6677 61.7674 68.1112 61.9928 67.4484 61.9913H55.7243C55.0599 61.9913 54.5034 61.7651 54.0548 61.3127C53.6061 60.8602 53.381 60.301 53.3794 59.635V56.6306C52.0116 57.6124 50.5359 58.3586 48.9524 58.8691C47.3689 59.3797 45.7181 59.635 44.0001 59.635C42.3197 59.635 40.6783 59.3703 39.076 58.8409C37.4737 58.3115 35.9886 57.5551 34.6208 56.5717V59.635C34.6208 60.3026 34.3957 60.8626 33.9455 61.315C33.4953 61.7674 32.9388 61.9928 32.276 61.9913H20.5519ZM25.2415 45.497C23.2875 45.497 21.6266 44.8098 20.2588 43.4352C18.8909 42.0607 18.207 40.3917 18.207 38.4281C18.207 36.4252 18.8909 34.7467 20.2588 33.3926C21.6266 32.0385 23.2875 31.3607 25.2415 31.3591C27.2346 31.3591 28.9057 32.0369 30.2548 33.3926C31.6038 34.7483 32.2776 36.4268 32.276 38.4281C32.276 40.3917 31.6022 42.0607 30.2548 43.4352C28.9073 44.8098 27.2362 45.497 25.2415 45.497ZM62.7588 45.497C60.8047 45.497 59.1438 44.8098 57.776 43.4352C56.4082 42.0607 55.7243 40.3917 55.7243 38.4281C55.7243 36.4252 56.4082 34.7467 57.776 33.3926C59.1438 32.0385 60.8047 31.3607 62.7588 31.3591C64.7519 31.3591 66.4229 32.0369 67.772 33.3926C69.1211 34.7483 69.7948 36.4268 69.7932 38.4281C69.7932 40.3917 69.1195 42.0607 67.772 43.4352C66.4245 44.8098 64.7534 45.497 62.7588 45.497Z" fill="#FFF4E7" />
</svg>

const Mobile_img = <svg width="88" height="89" viewBox="0 0 88 89" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect y="0.888184" width="88" height="88" rx="44" fill="#202020" />
  <path d="M52.1742 18.9395H35.8257C31.6267 18.9395 28.2051 22.2842 28.2051 26.4V63.3763C28.2051 67.4871 31.6216 70.8369 35.8257 70.8369H52.1715C56.3705 70.8369 59.7921 67.4921 59.7921 63.3763L59.7948 26.4C59.7948 22.2918 56.373 18.9395 52.1742 18.9395ZM44.0041 64.7954C42.5437 64.7954 41.3566 63.6332 41.3566 62.2035C41.3566 60.7738 42.5437 59.6116 44.0041 59.6116C45.4645 59.6116 46.6516 60.7738 46.6516 62.2035C46.6462 63.6332 45.4645 64.7954 44.0041 64.7954ZM47.3161 26.6834H40.6813C39.9256 26.6834 39.3093 26.08 39.3093 25.3403C39.3093 24.6004 39.9256 23.9971 40.6813 23.9971H47.3161C48.0718 23.9971 48.6881 24.6005 48.6881 25.3403C48.6881 26.0774 48.0798 26.6834 47.3161 26.6834Z" fill="#FFF4E7" />
</svg>

const Store_img = <svg width="88" height="89" viewBox="0 0 88 89" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect y="0.48584" width="88" height="88" rx="44" fill="#202020" />
  <path d="M61.8038 42.6919C59.5345 42.6919 57.4173 41.7958 55.8019 40.3307C54.1672 41.8383 52.0428 42.6919 49.7595 42.6919H48.8228C46.6119 42.6919 44.613 41.8559 43.0489 40.5251C41.4849 41.8577 39.486 42.6919 37.2751 42.6919H36.3384C34.055 42.6919 31.9307 41.84 30.2959 40.3307C28.6806 41.7958 26.5633 42.6919 24.2941 42.6919C23.5412 42.6919 22.8113 42.5929 22.1062 42.4179V59.1545C22.1062 61.0809 23.6791 62.6538 25.6055 62.6538H35.6456V51.3518C35.6456 49.4165 37.215 47.8472 39.1502 47.8472H46.9477C48.8829 47.8472 50.4523 49.4165 50.4523 51.3518V62.6538H60.4924C62.4188 62.6538 63.9917 61.0809 63.9917 59.1545V42.4179C63.2883 42.5929 62.5567 42.6919 61.8038 42.6919Z" fill="#FFF4E7" />
  <path d="M30.5574 27.3213H23.276C22.1025 27.3213 21.0156 27.9399 20.4183 28.9508L17.9087 33.187C16.2545 35.9794 18.2674 39.5105 21.5123 39.5105H23.8204C25.6761 39.5105 27.3091 38.2911 27.8357 36.5114L30.5574 27.3213Z" fill="#FFF4E7" />
  <path d="M41.4583 27.3213H33.8747L31.8565 34.1326C31.0612 36.8171 33.0724 39.5105 35.8718 39.5105H37.268C39.5814 39.5105 41.4566 37.6354 41.4566 35.322V27.3213H41.4583Z" fill="#FFF4E7" />
  <path d="M52.2231 27.3213H44.6395V35.322C44.6395 37.6354 46.5146 39.5105 48.828 39.5105H50.2242C53.0237 39.5105 55.0349 36.8171 54.2396 34.1326L52.2231 27.3213Z" fill="#FFF4E7" />
  <path d="M62.2791 39.5105H64.5872C67.832 39.5105 69.845 35.9794 68.1908 33.187L65.6812 28.9508C65.082 27.9416 63.9969 27.3213 62.8234 27.3213H55.542L58.2637 36.5114C58.7886 38.2911 60.4234 39.5105 62.2791 39.5105Z" fill="#FFF4E7" />
</svg>

const imageMap = {
  'Franchise_img': Franchise_img,
  'Mobile_img': Mobile_img,
  'Store_img': Store_img
};

const slideInFromLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const AnimatedImage = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  
  opacity: 0;
  ${props => props.inView && css`
    animation: ${slideInFromLeft} 1s ease-out forwards;
  `}
`;

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  overflow: hidden;
`;

const CardContentWrapper = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 10px 0;

  @media (min-width: 600px) {
    text-align: left;
  }
`;

const LinkText = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  margin-top: 20px;
  cursor: pointer;
`;

const KnowMoreContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff4e7;
  border-radius: 12px;
  transition: background 0.5s ease, transform 0.3s ease;
  max-width: 420px;
  width: 100%;

  &:hover {
    background: ${variables.primaryColor};
    h2, p {
      color: white !important;
    }
    svg {
      fill: white;
    }
    path {
      fill: aqua;
    }
    svg {
      filter: invert(1);
    }
    img {
      filter: brightness(0) invert(1);
    }
  }
`;

export default function KnowMoreComponent() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const router = useRouter();

  const handleRedirect = (e) => {
    if (e.title === "Become a Pappad Partner") {
      router.push('/franchise');
    } else if (e.title === "Download the App") {
      window.open('https://onelink.to/s5pgev', '_blank');
    } else if (e.title === "Add your Restaurant to Pappad") {
      const element = document.getElementById("contact-us");
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <Box component="div" sx={{ mt: 8, px: { xs: 0, sm: 3, md: 8 } }} id="know-more">
      <Container maxWidth="xl">
        <ImageContainer ref={ref}>
          {cards.map((card, index) => (
            <AnimatedImage
              key={index}
              inView={inView}
              style={{ animationDelay: `${index * 0.5}s` }}
            >
              <KnowMoreContainer>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'column' }, padding: { xs: '10px', sm: '24px' } }}>
                  <Box sx={{ display: 'flex', width: '100%', marginBottom: 2 }}>
                    {imageMap[card.image]}
                  </Box>
                  <CardContentWrapper>
                    <Box sx={{ height: { xs: '290px', sm: '250px', md: '220px' } }}>
                      <HeadingText sx={{ fontSize: '24px', textAlign: { xs: 'left' } }}>
                        {card.title}
                      </HeadingText>
                      <ParagraphText sx={{ fontSize: '15px', mt: 1, textAlign: { xs: 'left' } }}>
                        {card.description}
                      </ParagraphText>
                    </Box>
                    <LinkText onClick={() => { handleRedirect(card) }}>
                      <HeadingText style={{ fontSize: '16px' }}>
                        {card.linkText}
                      </HeadingText>
                      <Image
                        alt={card.linkText}
                        src={Arrow_img}
                      />
                    </LinkText>
                  </CardContentWrapper>
                </Box>
              </KnowMoreContainer>
            </AnimatedImage>
          ))}
        </ImageContainer>
      </Container>
    </Box>
  );
}